<template>
    <el-collapse v-model="active" accordion>
        <list-item
                v-for="item in items"
                :key="item.id"
                :item="item"
                :is-selected="isSelected(item)"
                @select="onSelect"
        ></list-item>
    </el-collapse>
</template>

<script>
  import ListItem from './campaign-list-item';

  export default {
    components: {
      ListItem,
    },

    props: {
      items: Array,
      selected: Object,
    },

    data() {
      return {
        active: null,
      };
    },

    methods: {
      /**
       * @param {object} item
       */
      onSelect(item) {
        this.$emit('update:selected', item);
      },

      /**
       * @param {object} item
       * @return {boolean}
       */
      isSelected(item) {
        return this.selected === item;
      },
    },
  }
</script>
